/**
 * Layout paramètres : contenu limité à 650px (onglets = sous-barre dans NavbarSite).
 * @param {boolean} [withTopPadding=true] — Mettre à false quand le parent (grille + bandeau) applique déjà le pt-6.
 * @param {boolean} [innerScroll=true] — À false sur la grille + bandeau d’aide : un seul scroll (PageContainer), sinon le sticky du bandeau ne fonctionne pas correctement.
 */
const SettingsLayout = ({
  children,
  withTopPadding = true,
  innerScroll = true,
}) => (
  <div
    className={`flex w-full max-w-[650px] min-h-0 flex-1 flex-col gap-4 px-[20px] pb-6 ${
      innerScroll ? "overflow-y-auto" : "overflow-visible"
    } ${withTopPadding ? "pt-6" : "pt-0"}`}
  >
    {children}
  </div>
);

export default SettingsLayout;
